import React, { Component } from 'react';

class Header extends Component {
    render()
    {
        return (
            <div className="App-header">
                {this.props.showBackButton && <div onClick={this.props.onBack}><img width={15} height={29} src={"back.png"} /></div>}
                {!this.props.showBackButton && <div><img width={15} height={29} src={"tr.png"} /></div>}
                <div style={{fontSize:35}}>{this.props.text}</div>
                <div onClick={this.props.onRefresh}><img width={29} height={29} src={"refresh.png"} /></div>
            </div>
        );
    }
}

export default Header;
